<!--
   使用
     更改默认值 :fatherData="{limitCount: 1, size: 2, type: ['jpeg', 'jpg', 'png', 'bmp', 'gif', 'ai'] }"
     默认图片 :imgList= [{
          name: '320F50BF-B254-448a-A0E9-91D2F3BD8E8D.png',
          url: 'https://flkj-flshop.oss-cn-shanghai.aliyuncs.com/320F50BF-B254-448a-A0E9-91D2F3BD8E8D.png'
        }]
      1.  导入  import UploadImage from '@/views/_common/UploadImage';
      2.   components: {
              'UploadImage': UploadImage
           },
      3.  <UploadImage ref='UploadImage'></UploadImage>
      4.  获取图片列表 this.$refs.UploadImage.getImgList()
-->

<template>
  <div class="UploadImage">
    <el-upload
      list-type="picture-card"
      drag
      :action="uploadImgUrl"
      :headers="{bearer: jwt}"
      :limit="limitCount"
      :file-list="fileList"
      :on-exceed="handleExceed"
      :before-upload="handleBeforeUpload"
      :on-success="handleSuccess"
      :on-remove="handleRemove"
      :on-preview="handlePictureCardPreview">
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  
  export default {
    name: 'UploadImage',
    inject: ['myMessage'],
    props: {
      fatherData: Object,
      imgList: Array
    },
    data () {
      return {
        dialogVisible: false,
        dialogImageUrl: '',
        limitCount: 1,
        type: ['jpeg', 'jpg', 'png', 'bmp', 'gif', 'ai'],
        size: 2, // M
        fileList: []
      };
    },
    computed: {
      ...mapGetters([
        'uploadImgUrl',
        'jwt'
      ])
    },
    watch: {
      imgList (val, oldVal) {
        this.fileList = this.imgList.concat([]);
      }
    },
    methods: {
      handleExceed () {
        this.myMessage.megError('最多可上传' + this.limitCount + '张照片');
      },
      
      handleBeforeUpload (file) {
        const isLtSize = file.size / 1024 / 1024 < this.size;
        let typeIsValidated = true;
        if (this.type.indexOf(file.type.split('/')[1]) < 0) {
          typeIsValidated = false;
        }
        
        if (!typeIsValidated) {
          this.myMessage.megError('图片只能是：' + this.type.join(',') + '格式');
        }
        if (!isLtSize) {
          this.myMessage.megError('图片不能超过：' + this.size + 'MB');
        }
        return typeIsValidated && isLtSize;
      },
      
      handleSuccess (response, file, fileList) {
        // eslint-disable-next-line eqeqeq
        if (response.meta && response.meta.code == 2000) {
          // this.fileList.push(response.dataset.data);
          file.url = response.dataset.data.url;
          file.name = response.dataset.data.name;
          this.fileList = fileList;
          // eslint-disable-next-line eqeqeq
        } else if (response.meta && response.meta.code == 1008) {
          this.myMessage.megError('身份已过期，重新登录');
          this.$store.dispatch('logOut')
            .then(() => {
              this.$router.push({ path: '/login' });
            });
        } else {
          this.myMessage.megError(response.meta.user_message);
          fileList.pop();
        }
      },
      
      handleRemove (file, fileList) {
        for (let i = 0; i < this.fileList.length; i++) {
          if (this.fileList[i].url === file.url) {
            this.fileList.splice(i, 1);
            break;
          }
        }
      },
      
      handlePictureCardPreview (file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      
      getImgList () {
        const resultArray = [];
        this.fileList.forEach(item => {
          resultArray.push({ name: item.name, url: item.url });
        });
        return resultArray;
      }
    },
    created () {
      if (this.fatherData) {
        if (this.fatherData.limitCount) {
          this.limitCount = this.fatherData.limitCount;
        }
        if (this.fatherData.type) {
          this.type = this.fatherData.type;
        }
        
        if (this.fatherData.size) {
          this.size = this.fatherData.size;
        }
      }
      if (this.imgList) {
        this.fileList = this.imgList.concat([]);
      }
    }
  };
</script>

<style lang="scss">
  .UploadImage {
    .el-upload,
    .el-upload-list__item {
      width: 148px !important;
      height: 148px !important;
    }
    
    .el-icon-plus {
      line-height: 148px !important;
      vertical-align: text-bottom;
    }
    
    .el-upload-dragger {
      width: 100% !important;
      height: 100% !important;
    }
  }
</style>
